import {ICatalogo} from "../../entities/catalogos/ICatalogo";
import {LOAD_PAISES_SUCCESS, PaisActionTypes} from "../types/paisActionTypes";


export default function paisReducer(state = [], action: PaisActionTypes): ICatalogo[] {
    switch (action.type) {
        case LOAD_PAISES_SUCCESS:
            return action.paises;
        default:
            return state;
    }
}

